// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* notification.css */

.notification-page {
  padding: 24px;
  color: #fff;
}

/* =========================
HEADER
========================= */

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 20px;
}

.notification-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.notification-subtitle {
  color: #9ca3af;
  margin-top: 4px;
  font-size: 14px;
}

.notification-send-btn {
  border: none;
  background: #ffcc00;
  color: #000;
  height: 48px;
  padding: 0 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
}

.notification-send-btn:hover {
  transform: translateY(-2px);
}

/* =========================
TABLE
========================= */

.notification-table-card {
  background: #081225;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
}

.notification-table {
  width: 100%;
  border-collapse: collapse;
}

.notification-table thead {
  background: #060e1d;
}

.notification-table th {
  padding: 18px;
  text-align: left;
  font-size: 14px;
  color: #fff;
}

.notification-table td {
  padding: 18px;
  font-size: 14px;
  color: #d1d5db;
  border-top: 1px solid rgba(255,255,255,0.06);
}

.notification-table tr:hover {
  background: rgba(255,255,255,0.03);
}

.empty-notification {
  text-align: center;
  padding: 30px !important;
}

/* =========================
MODAL
========================= */

.notification-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.notification-modal {
  width: 100%;
  max-width: 700px;
  background: #07152f;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  animation: popup 0.25s ease;
}

@keyframes popup {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* =========================
MODAL HEADER
========================= */

.notification-modal-header {
  padding: 22px 24px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.notification-modal-header h3 {
  margin: 0;
  font-size: 22px;
}

.close-modal-btn {
  width: 42px;
  height: 42px;
  border: none;
  background: rgba(255,255,255,0.08);
  color: #fff;
  border-radius: 10px;
  cursor: pointer;
}

/* =========================
BODY
========================= */

.notification-modal-body {
  padding: 24px;
}

.notification-form-group {
  margin-bottom: 22px;
}

.notification-form-group label {
  display: block;
  margin-bottom: 10px;
  font-size: 14px;
  color: #d1d5db;
}

.notification-form-group input,
.notification-form-group textarea {
  width: 100%;
  border: 1px solid rgba(255,255,255,0.08);
  background: #081a38;
  border-radius: 12px;
  padding: 14px;
  color: #fff;
  outline: none;
  font-size: 14px;
}

.notification-form-group input:focus,
.notification-form-group textarea:focus {
  border-color: #ffcc00;
}

/* =========================
RADIO
========================= */

.notification-radio-group {
  display: flex;
  gap: 20px;
}

.notification-radio {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
}

/* =========================
SEARCH
========================= */

.search-input-wrapper {
  position: relative;
}

.search-input-wrapper svg {
  position: absolute;
  left: 14px;
  top: 14px;
  color: #9ca3af;
}

.search-input-wrapper input {
  padding-left: 40px !important;
}

/* =========================
USER LIST
========================= */

.notification-user-list {
  background: #06142b;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  padding: 14px;
  max-height: 260px;
  overflow-y: auto;
}

.user-list-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.small-btn {
  border: none;
  padding: 10px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}

.small-btn.primary {
  background: #ffcc00;
  color: #000;
}

.small-btn.secondary {
  background: #253047;
  color: #fff;
}

.notification-user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: 0.2s;
  color: #fff;
}

.notification-user-item:hover {
  background: rgba(255,255,255,0.05);
}

.empty-users {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
}

.selected-count {
  margin-top: 16px;
  font-size: 15px;
  font-weight: 600;
}

.selected-count span {
  color: #ffcc00;
  margin-left: 6px;
}

/* =========================
FOOTER
========================= */

.notification-modal-footer {
  padding: 22px 24px;
  border-top: 1px solid rgba(255,255,255,0.08);
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}

.cancel-btn {
  border: none;
  background: #253047;
  color: #fff;
  height: 46px;
  padding: 0 20px;
  border-radius: 12px;
  cursor: pointer;
}

.send-final-btn {
  border: none;
  background: #ffcc00;
  color: #000;
  height: 46px;
  padding: 0 20px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.send-final-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* =========================
SCROLLBAR
========================= */

.notification-user-list::-webkit-scrollbar {
  width: 6px;
}

.notification-user-list::-webkit-scrollbar-thumb {
  background: #3b455a;
  border-radius: 20px;
}

/* USER LIST */

.notification-user-list {
  background: #081a38;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px;
  padding: 14px;
  max-height: 320px;
  overflow-y: auto;
}

/* HEADER */

.user-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.small-btn {
  border: none;
  min-width: 110px;
  height: 40px;
  padding: 0 16px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition: 0.2s;
}

.small-btn.primary {
  background: #ffcc00;
  color: #000;
}

.small-btn.secondary {
  background: #253047;
  color: #fff;
}

.small-btn:hover {
  transform: translateY(-1px);
}

/* USER ITEM */

.notification-user-item {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 58px;
  padding: 12px 14px;
  border-radius: 14px;
  cursor: pointer;
  transition: 0.2s;
  color: #fff;
  border: 1px solid transparent;
  margin-bottom: 8px;
  background: rgba(255,255,255,0.02);
}

.notification-user-item:hover {
  background: rgba(255,255,255,0.05);
  border-color: rgba(255,255,255,0.08);
}

/* CHECKBOX FIX */

.notification-user-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  min-width: 18px;
  cursor: pointer;
  accent-color: #ffcc00;
  margin: 0;
  flex-shrink: 0;
}

/* TEXT FIX */

.notification-user-item span {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
  color: #f3f4f6;
  line-height: 1.4;

  /* name break fix */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* EMPTY */

.empty-users {
  text-align: center;
  padding: 28px 20px;
  color: #9ca3af;
  font-size: 14px;
}

/* POPUP SCROLL FIX */

.notification-modal {
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  background: #07152f;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  animation: popup 0.25s ease;

  display: flex;
  flex-direction: column;
}

/* BODY SCROLL */

.notification-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;

  /* hide scrollbar */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.notification-modal-body::-webkit-scrollbar {
  display: none;
}

/* USER LIST SCROLL HIDE */

.notification-user-list {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.notification-user-list::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/notification/notification.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;2BAE2B;;AAE3B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;2BAE2B;;AAE3B;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,cAAc;;AAEd;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA,iBAAiB;;AAEjB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,cAAc;AAChB;;AAEA,aAAa;;AAEb;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;;EAEhB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,UAAU;;AAEV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;;AAErB;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,2BAA2B;;EAE3B,aAAa;EACb,sBAAsB;AACxB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;;EAEP,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;;AAE1B;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* notification.css */\n\n.notification-page {\n  padding: 24px;\n  color: #fff;\n}\n\n/* =========================\nHEADER\n========================= */\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 20px;\n}\n\n.notification-title {\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.notification-subtitle {\n  color: #9ca3af;\n  margin-top: 4px;\n  font-size: 14px;\n}\n\n.notification-send-btn {\n  border: none;\n  background: #ffcc00;\n  color: #000;\n  height: 48px;\n  padding: 0 20px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.notification-send-btn:hover {\n  transform: translateY(-2px);\n}\n\n/* =========================\nTABLE\n========================= */\n\n.notification-table-card {\n  background: #081225;\n  border-radius: 18px;\n  overflow: hidden;\n  border: 1px solid rgba(255,255,255,0.08);\n}\n\n.notification-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.notification-table thead {\n  background: #060e1d;\n}\n\n.notification-table th {\n  padding: 18px;\n  text-align: left;\n  font-size: 14px;\n  color: #fff;\n}\n\n.notification-table td {\n  padding: 18px;\n  font-size: 14px;\n  color: #d1d5db;\n  border-top: 1px solid rgba(255,255,255,0.06);\n}\n\n.notification-table tr:hover {\n  background: rgba(255,255,255,0.03);\n}\n\n.empty-notification {\n  text-align: center;\n  padding: 30px !important;\n}\n\n/* =========================\nMODAL\n========================= */\n\n.notification-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.7);\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n\n.notification-modal {\n  width: 100%;\n  max-width: 700px;\n  background: #07152f;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid rgba(255,255,255,0.08);\n  animation: popup 0.25s ease;\n}\n\n@keyframes popup {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* =========================\nMODAL HEADER\n========================= */\n\n.notification-modal-header {\n  padding: 22px 24px;\n  border-bottom: 1px solid rgba(255,255,255,0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.notification-modal-header h3 {\n  margin: 0;\n  font-size: 22px;\n}\n\n.close-modal-btn {\n  width: 42px;\n  height: 42px;\n  border: none;\n  background: rgba(255,255,255,0.08);\n  color: #fff;\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n/* =========================\nBODY\n========================= */\n\n.notification-modal-body {\n  padding: 24px;\n}\n\n.notification-form-group {\n  margin-bottom: 22px;\n}\n\n.notification-form-group label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 14px;\n  color: #d1d5db;\n}\n\n.notification-form-group input,\n.notification-form-group textarea {\n  width: 100%;\n  border: 1px solid rgba(255,255,255,0.08);\n  background: #081a38;\n  border-radius: 12px;\n  padding: 14px;\n  color: #fff;\n  outline: none;\n  font-size: 14px;\n}\n\n.notification-form-group input:focus,\n.notification-form-group textarea:focus {\n  border-color: #ffcc00;\n}\n\n/* =========================\nRADIO\n========================= */\n\n.notification-radio-group {\n  display: flex;\n  gap: 20px;\n}\n\n.notification-radio {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #fff;\n}\n\n/* =========================\nSEARCH\n========================= */\n\n.search-input-wrapper {\n  position: relative;\n}\n\n.search-input-wrapper svg {\n  position: absolute;\n  left: 14px;\n  top: 14px;\n  color: #9ca3af;\n}\n\n.search-input-wrapper input {\n  padding-left: 40px !important;\n}\n\n/* =========================\nUSER LIST\n========================= */\n\n.notification-user-list {\n  background: #06142b;\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 14px;\n  padding: 14px;\n  max-height: 260px;\n  overflow-y: auto;\n}\n\n.user-list-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.small-btn {\n  border: none;\n  padding: 10px 14px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.small-btn.primary {\n  background: #ffcc00;\n  color: #000;\n}\n\n.small-btn.secondary {\n  background: #253047;\n  color: #fff;\n}\n\n.notification-user-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: 0.2s;\n  color: #fff;\n}\n\n.notification-user-item:hover {\n  background: rgba(255,255,255,0.05);\n}\n\n.empty-users {\n  text-align: center;\n  padding: 20px;\n  color: #9ca3af;\n}\n\n.selected-count {\n  margin-top: 16px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.selected-count span {\n  color: #ffcc00;\n  margin-left: 6px;\n}\n\n/* =========================\nFOOTER\n========================= */\n\n.notification-modal-footer {\n  padding: 22px 24px;\n  border-top: 1px solid rgba(255,255,255,0.08);\n  display: flex;\n  justify-content: flex-end;\n  gap: 14px;\n}\n\n.cancel-btn {\n  border: none;\n  background: #253047;\n  color: #fff;\n  height: 46px;\n  padding: 0 20px;\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.send-final-btn {\n  border: none;\n  background: #ffcc00;\n  color: #000;\n  height: 46px;\n  padding: 0 20px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.send-final-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* =========================\nSCROLLBAR\n========================= */\n\n.notification-user-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.notification-user-list::-webkit-scrollbar-thumb {\n  background: #3b455a;\n  border-radius: 20px;\n}\n\n/* USER LIST */\n\n.notification-user-list {\n  background: #081a38;\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 16px;\n  padding: 14px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n/* HEADER */\n\n.user-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.small-btn {\n  border: none;\n  min-width: 110px;\n  height: 40px;\n  padding: 0 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  transition: 0.2s;\n}\n\n.small-btn.primary {\n  background: #ffcc00;\n  color: #000;\n}\n\n.small-btn.secondary {\n  background: #253047;\n  color: #fff;\n}\n\n.small-btn:hover {\n  transform: translateY(-1px);\n}\n\n/* USER ITEM */\n\n.notification-user-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-height: 58px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  cursor: pointer;\n  transition: 0.2s;\n  color: #fff;\n  border: 1px solid transparent;\n  margin-bottom: 8px;\n  background: rgba(255,255,255,0.02);\n}\n\n.notification-user-item:hover {\n  background: rgba(255,255,255,0.05);\n  border-color: rgba(255,255,255,0.08);\n}\n\n/* CHECKBOX FIX */\n\n.notification-user-item input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  min-width: 18px;\n  cursor: pointer;\n  accent-color: #ffcc00;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n/* TEXT FIX */\n\n.notification-user-item span {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n  color: #f3f4f6;\n  line-height: 1.4;\n\n  /* name break fix */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* EMPTY */\n\n.empty-users {\n  text-align: center;\n  padding: 28px 20px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n/* POPUP SCROLL FIX */\n\n.notification-modal {\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  background: #07152f;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid rgba(255,255,255,0.08);\n  animation: popup 0.25s ease;\n\n  display: flex;\n  flex-direction: column;\n}\n\n/* BODY SCROLL */\n\n.notification-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n\n  /* hide scrollbar */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.notification-modal-body::-webkit-scrollbar {\n  display: none;\n}\n\n/* USER LIST SCROLL HIDE */\n\n.notification-user-list {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.notification-user-list::-webkit-scrollbar {\n  display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
